<template>
    <SbsTooltip v-bind="tooltipData" ref="pictureInPicture" class="sbs-videolayer-screen-icon">
        <div class="sbs-videolayer-screen-icon__icon-wrapper" @click="this.setPictureInPictureToggleTooltipText">
            <InlineSvg class="sbs-videolayer-screen-icon__icon" :src="screenIcon" />
        </div>
    </SbsTooltip>
</template>

<script>
import InlineSvg from 'vue-inline-svg';
import { toRaw } from 'vue';
import SbsTooltip from '../../tooltip/SbsTooltip.vue';
import screenIcon from '../../../assets/svg/video-screen-icon.svg';

export default {
    name: 'SbsVideoPlayerPictureInPicture',
    components: {
        SbsTooltip,
        InlineSvg,
    },
    inject: {
        videoPlayerComponent: { default: null },
    },
    data() {
        return {
            pictureInPictureToggleComponent: null,
            pictureInPictureToggleTooltipText: 'Оконный режим',
            screenIcon,
        };
    },
    computed: {
        player() {
            return toRaw(this.videoPlayerComponent.player);
        },
        tooltipData() {
            return {
                parentSelector: this.videoPlayerComponent.videoContainerSelector,
                offset: 0,
                position: 'top',
                width: this.isPictureInPictureTooltipWidth,
                content: this.pictureInPictureToggleTooltipText,
            };
        },
        isPictureInPictureTooltipWidth() {
            return this.player.isInPictureInPicture()
                ? '200'
                : '138';
        },
    },
    methods: {
        setPictureInPictureToggleTooltipText() {
            // eslint-disable-next-line no-negated-condition
            if (!this.player.isInPictureInPicture()) {
                this.player.requestPictureInPicture();
            } else {
                this.player.exitPictureInPicture();
            }

            this.pictureInPictureToggleTooltipText = this.player.isInPictureInPicture()
                ? 'Оконный режим'
                : 'Выход из оконного режима';
        },
    },
    mounted() {
        this.player.controlBar.addChild('Component', {
            el: this.$refs.pictureInPicture.$el,
        });
    },
};
</script>

<style lang="scss">
@import "../styles/mixins.scss";

// stylelint-disable declaration-no-important
.vjs-picture-in-picture .vjs-picture-in-picture-control .vjs-icon-placeholder::before {
    width: 22px;
    height: 36px;
    margin-left: 9px;
    border-bottom: 2px solid var(--video-player-theme);
}

.video-js.vjs-picture-in-picture .vjs-picture-in-picture-control .vjs-icon-placeholder::before {
    content: "\f121" !important;
}

.vjs-subtitles-button.vjs-control {
    cursor: pointer;

    .vjs-control-bar & {
        width: 20px;
        margin-right: 10px;
        margin-left: 10px;
    }

    &.active .vjs-icon-placeholder::before {
        width: 22px;
        height: 36px;
        border-bottom: 2px solid var(--video-player-theme);
    }
}

.sbs-videolayer-screen-icon__icon-wrapper {
    @include video-icon-wrapper;
}

.sbs-videolayer-screen-icon__icon {
    @include video-icon;
}
</style>
